module.exports = __webpack_public_path__ + "media/images/super-6237a8e9be163e4b9fda4d1aa8b97062.png";